import { render } from "./GameView.vue?vue&type=template&id=970b7ae4&scoped=true&ts=true"
import script from "./GameView.vue?vue&type=script&lang=ts"
export * from "./GameView.vue?vue&type=script&lang=ts"

import "./GameView.vue?vue&type=style&index=0&id=970b7ae4&lang=scss&scoped=true"
import "./GameView.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970b7ae4"]])

export default __exports__